import store from "../../../store";
import { COUNTRY_CODES } from "../../../utils/constants";
import zipCodes from "../../../../../src/address-zip-codes.json";

const headerHTML = (formName: any, createLeadCaptureId: any) => {
  const storedData = localStorage.getItem("loginData");
  const parsedData = storedData ? JSON.parse(storedData) : null;
  const appState = store.getState();
  const host = `${appState.server.serverProtocol}://${appState.server.serverUrl}:${appState.server.serverPort}`;
  const tenantId = parsedData?.tenantDetails?.id || null;
  const userId = parsedData?.userDetails?.id || null;
  const primaryColor = parsedData?.tenantDetails?.primaryColor || "#887952";
  const formLogo =
    parsedData?.tenantDetails?.logoUrl ||
    "https://www.w3schools.com/w3images/avatar2.png";
  return `<!DOCTYPE html>
<html lang="en" xml:lang="en">
    <head>
        <title>Lead Capture Form</title>
        <link href='https://fonts.googleapis.com/css?family=Roboto' rel='stylesheet'>
        <style>
            .lead-capture-form{
                width: 100%;
                height: 100vh;
                background-color: black;
                font-family: roboto!important;
            }
            .lead-capture-form-container{
                width: 70%;
                margin: 0 auto;
                background-color: white!important;
                height: 100vh;
                overflow: auto;
            }
            .lead-capture-form-container-header-img-text{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 14px 22px;
                background-color: white!important;
                border-bottom: 1px solid #E1E1E1;
                width: calc(100% - 44px);
                height: 51px;
            }
            .lead-capture-form-container-header-img{
                height: 51px;
                width: 51px;
                background-color: white!important;
            }
            .lead-capture-form-container-header-img img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            .lead-capture-form-container-header-text{
                margin-left: 10px;
                font-family: roboto;
                font-weight: 600;
                font-size: 20px;
                line-height: 100%;
                letter-spacing: 0px;
                color: #000000;
                background-color: white!important;

            }
            .lead-capture-form-container-form{
                width: calc(100% - 44px);
                padding: 14px 22px;
            }
            .lead-capture-form-container-form-secton{
                border: 1px solid #E1E1E1;
                border-radius: 4px;
                margin-bottom: 20px;
            }
            .lead-capture-form-container-form-element{
                width: calc(100% - 44px);
                padding: 14px 20px;
                
            }
            .lead-capture-form-container-form-element label{
                font-family: roboto;
                font-weight: 400;
                font-size: 14px;
                line-height: 14px;
                letter-spacing: 0px;
                color: #212121
            }
            .lead-capture-form-container-form-secton-header{
                width: calc(100% - 44px);
                padding: 14px 20px;
                border-bottom: 1px solid #E1E1E1;
                font-family: Roboto;
                font-weight: 500;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #212121;

            }
            .upload-container {
            transition: all 0.3s ease;
            display: flex;
            flex-direction: column;
            width: 200px;
            }

            .file-input {
            display: none;
            }

            .upload-label {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 8px;
            padding: 8px 0px;
            }

            .upload-content {
            display: flex;
            align-items: center;
            cursor: pointer;
            }

            .upload-img {
            width: 55px!important;
            height: 55px!important;
            border-radius: 100%;
            background: #f4f4f4;
            margin-bottom: 8px;
            }

            .upload-text {
            cursor: pointer;
            font-size: 14px;
            padding-left: 8px;
            }
            .required-element:after {
                content:" *";
                color: red;
            }
            .error-message{
                color: red;
                font-size: 12px;
                margin-top: 5px;
            }
            input:valid{
                border: 1px solid #ccc;
            }
            
            input[type=text],input[type=email], input[type=number],select {
            width: 100%;
            padding: 12px 20px;
            margin: 8px 0;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            box-sizing: border-box;
            }



            input[type=button], input[type=submit]:hover {
                width: 200px;
                margin-left: calc(50% - 100px);
            }

            input[type=button], input[type=submit] {
            background-color: ${primaryColor};
            color: white;
            padding: 14px 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            }

            input[type=button], input[type=submit]:hover {
            background-color:  ${primaryColor};
            }
            select {
            cursor: pointer;
            }
            select:invalid { color: gray; }
            .custom-multiselect-container {
                position: relative;
                width: 100%;
            }

            .custom-multiselect-display {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border: 1px solid #ccc;
                padding: 12px 20px;
                background-color: white;
                cursor: pointer;
                border-radius: 4px;
                min-height: 20px;
                color: #666;
                margin: 8px 0px;
                font-size: 14px;
            }

            .custom-multiselect-display .arrow {
                margin-left: auto;
                border: solid black;
                border-width: 0 1px 1px 0;
                display: inline-block;
                padding: 3px;
            }

            .custom-multiselect-dropdown {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background-color: white;
                border: 1px solid #ccc;
                border-top: none;
                border-radius: 0 0 4px 4px;
                max-height: 60px;
                overflow-y: auto;
                z-index: 1000;
                display: none;
            }

            .custom-multiselect-dropdown.show {
                display: block;
            }

            .checkbox-container {
                display: block;
                position: relative;
                padding: 8px 12px 8px 35px;
                cursor: pointer;
                font-size: 14px;
                user-select: none;
            }

            .checkbox-container:hover {
                background-color: #f1f1f1;
            }

            .checkbox-container input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
            }

            .checkmark {
                position: absolute;
                top: 50%;
                left: 12px;
                transform: translateY(-50%);
                height: 15px;
                width: 15px;
                background-color: #eee;
                border: 1px solid #ccc;
                border-radius: 2px;
            }

            .checkbox-container:hover input ~ .checkmark {
                background-color: #ccc;
            }

            .checkbox-container input:checked ~ .checkmark {
                background-color: ${primaryColor};
                border-color: ${primaryColor};
            }

            .checkmark:after {
                content: "";
                position: absolute;
                display: none;
                left: 4px;
                top: 1px;
                width: 3px;
                height: 7px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
            }

            .checkbox-container input:checked ~ .checkmark:after {
                display: block;
            }

            /* Phone Input with Country Code Styles */
            .phone-input-container {
                display: flex;
                width: 100%;
                overflow: visible;
                position: relative;
            }

            .country-selector {
                position: relative;
                width: 100px;
                min-width: 100px;
                max-width: 140px;
                flex-shrink: 0;
            }

            .country-display {
                display: flex;
                align-items: center;
                background-color: #f8f9fa;
                border: none;
                border: 1px solid #ccc;
                border-radius: 4px 0 0 4px;
                padding: 12px 8px;
                margin: 8px 0px;
                font-size: 14px;
                cursor: pointer;
                outline: none;
                width: 100%;
                box-sizing: border-box;
            }

            .country-display:hover {
                background-color: #e9ecef;
            }

            .country-code {
                font-weight: 500;
                flex: 1;
            }
            
            .arrow {
            border: solid black;
            border-width: 0 2px 2px 0;
            display: inline-block;
            padding: 3px;
            }

            .down {
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            }

            .up {
            transform: rotate(-135deg);
            -webkit-transform: rotate(-135deg);
            }

            .country-dropdown {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background: white;
                border: 1px solid #ccc;
                border-top: none;
                border-radius: 0 0 4px 4px;
                max-height: 100px;
                overflow-y: auto;
                z-index: 1000;
                display: none;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                width: 160px;
            }

            .country-dropdown.show {
                display: block;
            }

            .country-search {
                width: calc(100% - 16px) !important;
                padding: 8px !important;
                border: none;
                border-bottom: 1px solid #eee;
                outline: none;
                font-size: 14px;
                margin: 8px !important;
            }

            .country-option {
                display: flex;
                align-items: center;
                padding: 10px 12px;
                cursor: pointer;
                font-size: 14px;
                border-bottom: 1px solid #f5f5f5;
            }

            .country-option:hover {
                background-color: #f8f9fa;
            }

            .country-option.selected {
                background-color: ${primaryColor};
                color: white;
            }

            .country-option-details {
                display: flex;
                flex-direction: column;
                flex: 1;
            }

            .country-option-name {
                font-weight: 500;
            }

            .country-option-code {
                font-size: 12px;
                color: #666;
                margin-top: 2px;
            }

            .phone-number-input {
                flex: 1;
                padding: 12px;
                font-size: 14px;
                background-color: white;
            }

            /* Address Dropdown Styles */
            .address-select-container {
                position: relative;
                width: 100%;
            }

            .address-select-container select {
                width: 100%;
                padding: 12px;
                margin: 8px 0;
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: white;
                font-size: 14px;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                cursor: pointer;
                max-height: 150px;
                overflow-y: auto;
            }

            /* Custom Select Container with Arrow */
            .custom-select-container {
                position: relative;
                width: 100%;
            }

            .custom-select-container select {
                width: 100%;
                padding-right: 40px;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
            }

            .custom-select-container .arrow {
                position: absolute;
                top: 50%;
                right: 15px;
                transform: translateY(-50%);
                border: solid black;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 3px;
                pointer-events: none;
            }

            /* Searchable Address Dropdown Styles */
            .address-selector {
                position: relative;
                width: 100%;
            }

            .address-display {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 20px;
                margin: 8px 0;
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: white;
                font-size: 14px;
                cursor: pointer;
                min-height: 20px;
            }

            .address-display .arrow {
                margin-left: auto;
                border: solid black;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 3px;
            }

            .address-dropdown {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background-color: white;
                border: 1px solid #ccc;
                border-radius: 4px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                z-index: 1000;
                display: none;
                max-height: 250px;
                overflow: hidden;
            }

            .address-dropdown.show {
                display: block;
            }

            .address-search {
                width: 100%;
                padding: 10px;
                border: none;
                border-bottom: 1px solid #eee;
                font-size: 14px;
                outline: none;
                box-sizing: border-box;
            }

            .address-options {
                max-height: 200px;
                overflow-y: auto;
                padding: 0;
            }

            .address-option {
                padding: 10px 15px;
                cursor: pointer;
                border-bottom: 1px solid #f0f0f0;
                font-size: 14px;
                color: #333;
            }

            .address-option:hover {
                background-color: #f5f5f5;
            }

            .address-option.selected {
                background-color: ${primaryColor};
                color: white;
            }

            .address-clear-btn {
                position: absolute;
                right: 35px;
                top: 50%;
                transform: translateY(-50%);
                background: none;
                border: none;
                font-size: 18px;
                font-weight: bold;
                color: #999;
                cursor: pointer;
                padding: 0;
                width: 20px;
                height: 20px;
                display: none;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                z-index: 10;
            }

            .address-display:hover .address-clear-btn {
                display: flex;
            }

            .address-clear-btn:hover {
                background-color: #f0f0f0;
                color: #666;
            }
        </style>
        <script>
            let imageUrl = null;
            window.onload = function(){
                document.getElementById('formLogo').src = '${formLogo}';
                document.getElementById("formName").textContent = '${formName}';
            }

         function handleErrorCheck() {
            const elementsError = document.querySelectorAll('.lead-capture-form-container-form-element input, .lead-capture-form-container-form-element select');
                elementsError.forEach((element) => { 
                    if (element.hasAttribute("required") && element.value !== "") {
                        isValid = false;
                        let errorMessageElementName = element.id + '-error-message';
                        const errorMessageElement = document.getElementById(errorMessageElementName)
                        if (errorMessageElement) {
                            errorMessageElement.textContent = "";
                        }
                    }
                });
            }

            function handleFileSelect() {
                
                    document.getElementById('imageUrl').click();
                    document.getElementById('imageUrl')?.addEventListener('change', (event) => {
                        const file = event.target.files[0];
                            if(file?.size > 110 * 1024 * 1024)
                            {
                                alert("Please upload max 100MB file");
                                return;
                            }
                        if (file) {
                            imageUrl = file;
                            document.getElementById('photoFile').src = URL.createObjectURL(file);
                            return;
                        }
                    });
              
            }
            function handleFormSubmit(event) {
            document.getElementById("submit-btn").disabled = true;
            const elements = document.querySelectorAll('.lead-capture-form-container-form-element input, .lead-capture-form-container-form-element select');
                let isValid = true;
                elements.forEach((element) => {
                    if (element.hasAttribute("required") && (element.value === "" || element.value === null || element.value === undefined)) {
                        isValid = false;
                        let errorMessageElementName = element.id + '-error-message';
                        const errorMessageElement = document.getElementById(errorMessageElementName)
                        if (errorMessageElement) {
                            errorMessageElement.textContent = "This field is required!";
                        }
                    }
                    else {
                        let errorMessageElementName = element.id + '-error-message';
                        const errorMessageElement = document.getElementById(errorMessageElementName)
                        if (errorMessageElement) {
                            errorMessageElement.textContent = "";
                        }
                    }
                });
                if (!isValid) {
                    document.getElementById("submit-btn").disabled = false;
                    return;
                }
                const leadDetails = {
                    firstName: document.getElementById('firstName')?.value || null,
                    lastName: document.getElementById('lastName')?.value || null,
                    primaryEmail: document.getElementById('email')?.value || null,
                    secondaryEmail: document.getElementById('secondaryEmail')?.value || null,
                    primaryPhoneNumber: document.getElementById('primaryPhoneNumber')?.value || null,
                    secondaryPhoneNumber: document.getElementById('secondaryPhoneNumber')?.value || null,
                    website: document.getElementById('website')?.value || null,
                    leadSource: document.getElementById('leadSource')?.value || "Sales Email",
                    leadStatus: document.getElementById('leadStatus')?.value || "New Lead",
                    faxNumber: document.getElementById('fax')?.value || null,
                    industry: document.getElementById('industry')?.value|| null,
                    interestedProducts: document.getElementById('interestedProduct')?.value,
                    confidenceScore: document.getElementById('rating')?.value || null,
                    socialLeadId: document.getElementById('socialLeadId')?.value || null,
                    description: document.getElementById('description')?.value || null,
                    designation: document.getElementById('designation')?.value || null,
                    middleName: document.getElementById('middleName')?.value || null,
                    age: parseInt(document.getElementById('age')?.value || 0) || null,
                    leadValue: document.getElementById('leadValue')?.value || null,
                    maritalStatus: document.getElementById('maritalStatus')?.value || null,
                    company: document.getElementById('company')?.value || null,
                    preferredContactMode: document.getElementById('preferredContactMode')?.value || null,
                };
                const formData = new FormData();
                Object.entries(leadDetails).forEach(([key, value]) => {
                    if (value) formData.append(key, value);
                });
                formData.append("address[streetLine1]", document.getElementById("streetAddress")?.value || null);
                formData.append("address[city]", document.getElementById("city")?.value || null);
                formData.append("address[state]", document.getElementById("state")?.value || null);
                formData.append("address[country]", document.getElementById("country")?.value || null);
                formData.append("address[zipcode]", document.getElementById("zipcode")?.value || null);
                if (imageUrl  instanceof File) {
                    formData.append("leadImg", imageUrl );
                }
                formData.append("userId", ${userId} );
                let request = new XMLHttpRequest();
                request.open('POST', '${host}/api/v1/tenant/${tenantId}/lead-capture-form/${createLeadCaptureId}/leads');
                request.onloadend = (event) => {
                const response=JSON.parse(request?.response)
                if(response?.success){
                    document.getElementById("submit-btn").disabled = false;
                    alert(response?.data?.message || "Lead Created Successfully");
                    location.reload();
                }else{
                    document.getElementById("submit-btn").disabled = false;
                    alert(response?.message || "There was an error making the request.");
                 }
        }   
                 request.onerror = function(event) {
                    document.getElementById("submit-btn").disabled = false;
                    alert('There was an error making the request.');
                };
                request.send(formData);
            }

            const InterestedProductMultiSelect = {
                elements: {
                    dropdown: null,
                    display: null,
                    hiddenInput: null,
                    checkboxes: null
                },
                
                init() {
                    this.elements.dropdown = document.getElementById('interestedProduct-dropdown');
                    this.elements.display = document.getElementById('interestedProduct-display');
                    this.elements.hiddenInput = document.getElementById('interestedProduct');
                    this.elements.checkboxes = document.querySelectorAll('#interestedProduct-dropdown input[type="checkbox"]');
                    
                    this.bindEvents();
                },
                
                bindEvents() {
                    // Click outside handler
                    document.addEventListener('click', (event) => this.handleOutsideClick(event));
                    
                    // Keyboard accessibility
                    this.elements.display?.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.toggle();
                        }
                    });
                },
                
                toggle() {
                    if (!this.elements.dropdown) return;
                    const isVisible = this.elements.dropdown.classList.contains('show');
                    
                    if (isVisible) {
                        this.close();
                    } else {
                        this.open();
                    }
                },
                
                open() {
                    if (!this.elements.dropdown || !this.elements.display) return;
                    
                    // Show dropdown
                    this.elements.dropdown.classList.add('show');
                    
                    // Change arrow to up position
                    const arrow = this.elements.display.querySelector('.arrow');
                    if (arrow) {
                        arrow.classList.remove('down');
                        arrow.classList.add('up');
                    }
                },
                
                updateSelection() {
                    if (!this.elements.checkboxes || !this.elements.display || !this.elements.hiddenInput) return;
                    
                    const selectedItems = Array.from(this.elements.checkboxes)
                        .filter(checkbox => checkbox.checked)
                        .map(checkbox => ({
                            value: checkbox.value,
                            label: checkbox.value
                        }));
                    
                    this.updateDisplay(selectedItems);
                    this.updateHiddenInput(selectedItems);
                    
                    // Trigger validation
                    if (typeof handleErrorCheck === 'function') {
                        handleErrorCheck();
                    }
                },
                
                updateDisplay(selectedItems) {
                    if (!this.elements.display) return;
                    
                    const { textContent, color } = this.getDisplayText(selectedItems);
                    
                    // Find and preserve the arrow element
                    const arrow = this.elements.display.querySelector('.arrow');
                    
                    // Update only the text content while preserving the arrow
                    this.elements.display.innerHTML = '';
                    this.elements.display.appendChild(document.createTextNode(textContent));
                    
                    // Re-append the arrow if it exists
                    if (arrow) {
                        this.elements.display.appendChild(arrow);
                    }
                    
                    this.elements.display.style.color = color;
                },
                
                getDisplayText(selectedItems) {
                    if (selectedItems.length === 0) {
                        return { textContent: 'Select Interested Product', color: '#666' };
                    }
                    
                    if (selectedItems.length === 1) {
                        return { textContent: selectedItems[0].label, color: '#000' };
                    }
                    
                    return { 
                        textContent: selectedItems.map(item => item.label).join(', '),
                        color: '#000' 
                    };
                },
                
                updateHiddenInput(selectedItems) {
                    if (!this.elements.hiddenInput) return;
                    this.elements.hiddenInput.value = selectedItems.map(item => item.value).join(',');
                },
                
                handleOutsideClick(event) {
                    const container = document.querySelector('.custom-multiselect-container');
                    
                    if (container && !container.contains(event.target)) {
                        this.close();
                    }
                },
                
                close() {
                    if (!this.elements.dropdown || !this.elements.display) return;
                    
                    // Hide dropdown
                    this.elements.dropdown.classList.remove('show');
                    
                    // Change arrow back to down position
                    const arrow = this.elements.display.querySelector('.arrow');
                    if (arrow) {
                        arrow.classList.remove('up');
                        arrow.classList.add('down');
                    }
                }
            };
            
            // Initialize when DOM is ready
            document.addEventListener('DOMContentLoaded', function() {
                InterestedProductMultiSelect.init();
            });
            
            // Legacy function wrappers for backward compatibility
            function toggleInterestedProductDropdown() {
                InterestedProductMultiSelect.toggle();
            }
            
            function updateInterestedProductSelection() {
                InterestedProductMultiSelect.updateSelection();
            }

            // Phone Number with Country Code Functions
            const COUNTRY_CODES_LIST = ${JSON.stringify(COUNTRY_CODES)};

            function toggleCountryDropdown(fieldId) {
                const dropdown = document.getElementById('dropdown-' + fieldId);
                const isVisible = dropdown.classList.contains('show');
                
                // Reset all country arrows to down position first
                document.querySelectorAll('.country-display .arrow').forEach(arrow => {
                    arrow.classList.remove('up');
                    arrow.classList.add('down');
                });
                
                // Close all dropdowns first
                document.querySelectorAll('.country-dropdown').forEach(d => d.classList.remove('show'));
                
                if (!isVisible) {
                    dropdown.classList.add('show');
                    
                    // Change arrow to up position for the opened dropdown
                    const displayElement = document.getElementById('display-' + fieldId);
                    if (displayElement) {
                        const arrow = displayElement.querySelector('.arrow');
                        if (arrow) {
                            arrow.classList.remove('down');
                            arrow.classList.add('up');
                        }
                    }
                    
                    const searchInput = dropdown.querySelector('.country-search');
                    if (searchInput) {
                        searchInput.focus();
                        searchInput.value = '';
                        searchCountries(fieldId, ''); // Show all countries
                    }
                }
            }

            function selectCountry(fieldId, dialCode, name, iso2) {
                // Update the display using the specific ID
                const display = document.getElementById('display-' + fieldId);
                if (display) {
                    const codeSpan = display.querySelector('.country-code');
                    if (codeSpan) codeSpan.textContent = dialCode;
                }
                
                // Update hidden input
                const hiddenInput = document.getElementById(fieldId + '-country');
                if (hiddenInput) {
                    hiddenInput.value = dialCode;
                }
                
                // Update selected state in dropdown - use iso2 for unique identification
                const options = document.querySelectorAll('#options-' + fieldId + ' .country-option');
                options.forEach(option => {
                    option.classList.remove('selected');
                    // Use iso2 code for unique identification (handles multiple countries with same dial code)
                    if (option.getAttribute('data-country-iso2') === iso2) {
                        option.classList.add('selected');
                    }
                });
                
                // Close dropdown
                document.getElementById('dropdown-' + fieldId).classList.remove('show');
                
                // Update phone number validation
                const phoneInput = document.getElementById(fieldId + '-number');
                if (phoneInput) {
                    updatePhoneNumber(fieldId, dialCode, phoneInput.value);
                }
            }

            function searchCountries(fieldId, searchTerm) {
                const optionsContainer = document.getElementById('options-' + fieldId);
                const options = optionsContainer.querySelectorAll('.country-option');
                
                options.forEach(option => {
                    const countryName = option.getAttribute('data-country-name');
                    const countryCode = option.getAttribute('data-country-code');
                    const isVisible = countryName.includes(searchTerm.toLowerCase()) || 
                                    countryCode.includes(searchTerm);
                    
                    option.style.display = isVisible ? 'flex' : 'none';
                });
            }

            function updatePhoneNumber(fieldId, countryCode, phoneNumber) {
                const hiddenInput = document.getElementById(fieldId);
                if (hiddenInput) {
                    const fullNumber = countryCode && phoneNumber ? countryCode + ' ' + phoneNumber : '';
                    hiddenInput.value = fullNumber;
                    
                    // Trigger error check
                    if (typeof handleErrorCheck === 'function') {
                        handleErrorCheck();
                    }
                }
            }

            function formatPhoneNumber(input) {
                // Remove any non-numeric characters
                let value = input.value.replace(/[^0-9]/g, '');
                
                // Limit to 15 digits
                if (value.length > 15) {
                    value = value.slice(0, 15);
                }
                
                input.value = value;
                
                // Update the hidden field
                const fieldId = input.getAttribute('data-field-id');
                const countryInput = document.getElementById(fieldId + '-country');
                const countryCode = countryInput ? countryInput.value : '';
                
                updatePhoneNumber(fieldId, countryCode, value);
            }

            // Close dropdowns when clicking outside
            document.addEventListener('click', function(e) {
                if (!e.target.closest('.country-selector')) {
                    document.querySelectorAll('.country-dropdown').forEach(dropdown => {
                        // Only reset arrow if dropdown is actually open and being closed
                        if (dropdown.classList.contains('show')) {
                            dropdown.classList.remove('show');
                            
                            // Find the corresponding arrow and reset it
                            const dropdownId = dropdown.id; // e.g., "dropdown-primaryPhoneNumber"
                            const fieldId = dropdownId.replace('dropdown-', ''); // e.g., "primaryPhoneNumber"
                            const displayElement = document.getElementById('display-' + fieldId);
                            if (displayElement) {
                                const arrow = displayElement.querySelector('.arrow');
                                if (arrow) {
                                    arrow.classList.remove('up');
                                    arrow.classList.add('down');
                                }
                            }
                        }
                    });
                }
            });

            // Enhanced Address Management System
            const ZIP_CODE_DATA = ${JSON.stringify(zipCodes)};
            
            // Extract unique states and cities for dropdowns
            let uniqueStates = [];
            let citiesByState = {};
            let zipcodesByCity = {};
            
            // Initialize data structures
            function initializeAddressData() {
                const statesSet = new Set();
                
                ZIP_CODE_DATA.forEach(entry => {
                    const trimmedCity = entry.City.trim();
                    
                    statesSet.add(entry.State);
                    
                    if (!citiesByState[entry.State]) {
                        citiesByState[entry.State] = new Set();
                    }
                    citiesByState[entry.State].add(trimmedCity);
                    
                    const key = \`\${entry.State}|\${trimmedCity}\`;
                    if (!zipcodesByCity[key]) {
                        zipcodesByCity[key] = [];
                    }
                    zipcodesByCity[key].push(entry.Code);
                });
                
                uniqueStates = Array.from(statesSet).sort();
                
                // Convert Sets to sorted Arrays
                Object.keys(citiesByState).forEach(state => {
                    citiesByState[state] = Array.from(citiesByState[state]).sort();
                });
            }

            // Populate state options for searchable dropdown
            function populateStateOptions() {
                const optionsContainer = document.getElementById('options-state');
                if (!optionsContainer || !uniqueStates) return;
                
                optionsContainer.innerHTML = '';
                
                uniqueStates.forEach(state => {
                    const option = document.createElement('div');
                    option.className = 'address-option';
                    option.textContent = state;
                    option.onclick = () => selectAddressOption('state', state, state);
                    optionsContainer.appendChild(option);
                });
            }

            // Populate city options for searchable dropdown
            function populateCityOptions() {
                const optionsContainer = document.getElementById('options-city');
                const stateValue = document.getElementById('state').value;
                
                if (!optionsContainer || !stateValue || !citiesByState[stateValue]) return;
                
                optionsContainer.innerHTML = '';
                
                const citiesInState = citiesByState[stateValue] || [];
                
                citiesInState.forEach(city => {
                    const option = document.createElement('div');
                    option.className = 'address-option';
                    option.textContent = city;
                    option.onclick = () => selectAddressOption('city', city, city);
                    optionsContainer.appendChild(option);
                });
            }

            // Populate zipcode options for searchable dropdown
            function populateZipCodeOptions() {
                const optionsContainer = document.getElementById('options-zipcode');
                if (!optionsContainer) return;
                
                optionsContainer.innerHTML = '';
                
                const stateValue = document.getElementById('state').value;
                const cityValue = document.getElementById('city').value;
                
                let zipCodes = [];
                
                if (stateValue && cityValue) {
                    const key = \`\${stateValue}|\${cityValue}\`;
                    zipCodes = zipcodesByCity[key] || [];
                } else if (stateValue) {
                    // Get all ZIP codes for the state
                    const citiesInState = citiesByState[stateValue] || [];
                    zipCodes = [];
                    citiesInState.forEach(city => {
                        const key = \`\${stateValue}|\${city}\`;
                        if (zipcodesByCity[key]) {
                            zipCodes = zipCodes.concat(zipcodesByCity[key]);
                        }
                    });
                    zipCodes = [...new Set(zipCodes)].sort();
                } else {
                    // Show all ZIP codes (limited for performance)
                    zipCodes = Object.values(zipcodesByCity).flat().slice(0, 100);
                }
                
                zipCodes.forEach(zipcode => {
                    const option = document.createElement('div');
                    option.className = 'address-option';
                    option.textContent = zipcode;
                    option.onclick = () => selectAddressOption('zipcode', zipcode, zipcode);
                    optionsContainer.appendChild(option);
                });
            }

            // Legacy populate state dropdown (keeping for backward compatibility)
            function populateStateDropdown() {
                const stateSelect = document.getElementById('state');
                if (!stateSelect) return;
                
                stateSelect.innerHTML = '<option value="">Select State</option>';
                
                uniqueStates.forEach(state => {
                    const option = document.createElement('option');
                    option.value = state;
                    option.textContent = state;
                    stateSelect.appendChild(option);
                });
            }

            // Handle state selection
            function handleStateChange(select) {
                const selectedState = select.value;
                const citySelect = document.getElementById('city');
                
                if (!selectedState) {
                    // Reset city dropdown
                    citySelect.innerHTML = '<option value="">Select City</option>';
                    citySelect.disabled = true;
                    return;
                }
                
                // Enable and populate city dropdown
                citySelect.disabled = false;
                citySelect.innerHTML = '<option value="">Select City</option>';
                
                const cities = citiesByState[selectedState] || [];
                cities.forEach(city => {
                    const option = document.createElement('option');
                    option.value = city;
                    option.textContent = city;
                    citySelect.appendChild(option);
                });
                
                // Clear ZIP code if it doesn't match the selected state
                const zipcodeInput = document.getElementById('zipcode');
                if (zipcodeInput.value) {
                    const zipData = ZIP_CODE_DATA.find(entry => entry.Code === zipcodeInput.value);
                    if (zipData && zipData.State !== selectedState) {
                        zipcodeInput.value = '';
                    }
                }
                
                handleErrorCheck();
            }

            // Handle city selection
            function handleCityChange(select) {
                const selectedCity = select.value;
                const stateSelect = document.getElementById('state');
                const selectedState = stateSelect.value;
                
                if (selectedCity && selectedState) {
                    // Update ZIP code dropdown based on city/state
                    const zipcodeSelect = document.getElementById('zipcode');
                    const key = \`\${selectedState}|\${selectedCity}\`;
                    const zipCodes = zipcodesByCity[key] || [];
                    
                    // Clear and repopulate ZIP code dropdown with filtered options
                    zipcodeSelect.innerHTML = '<option value="">Select ZIP Code</option>';
                    
                    if (zipCodes.length === 1) {
                        // Auto-select if only one ZIP code
                        const option = document.createElement('option');
                        option.value = zipCodes[0];
                        option.textContent = zipCodes[0];
                        option.selected = true;
                        zipcodeSelect.appendChild(option);
                    } else if (zipCodes.length > 1) {
                        // Add all ZIP codes for this city/state
                        zipCodes.forEach(zipCode => {
                            const option = document.createElement('option');
                            option.value = zipCode;
                            option.textContent = zipCode;
                            zipcodeSelect.appendChild(option);
                        });
                        
                        // Clear current selection if it doesn't match available options
                        const currentZip = zipcodeSelect.value;
                        if (currentZip && !zipCodes.includes(currentZip)) {
                            zipcodeSelect.value = '';
                        }
                    }
                } else {
                    // Reset ZIP code dropdown when city is cleared
                    const zipcodeSelect = document.getElementById('zipcode');
                    zipcodeSelect.innerHTML = '<option value="">Select ZIP Code</option>';
                }
                
                handleErrorCheck();
            }

            // ZIP code dropdown functionality
            function populateZipCodeDropdown() {
                const zipSelect = document.getElementById('zipcode');
                if (!zipSelect || zipSelect.children.length > 1) return; // Already populated
                
                // Get filtered ZIP codes based on current state/city selection
                const stateSelect = document.getElementById('state');
                const citySelect = document.getElementById('city');
                const selectedState = stateSelect.value;
                const selectedCity = citySelect.value;
                
                let zipCodes = [];
                
                if (selectedState && selectedCity) {
                    const key = \`\${selectedState}|\${selectedCity}\`;
                    zipCodes = (zipcodesByCity[key] || []).map(code => ({ Code: code, State: selectedState, City: selectedCity }));
                } else if (selectedState) {
                    zipCodes = ZIP_CODE_DATA.filter(entry => entry.State === selectedState).slice(0, 100);
                } else {
                    zipCodes = ZIP_CODE_DATA.slice(0, 100); // Show first 100 ZIP codes
                }
                
                zipCodes.forEach(entry => {
                    const option = document.createElement('option');
                    option.value = entry.Code;
                    option.textContent = \`\${entry.Code} - \${entry.City}, \${entry.State}\`;
                    zipSelect.appendChild(option);
                });
            }

            function handleZipCodeChange(select) {
                const selectedZipCode = select.value;
                if (!selectedZipCode) return;
                
                const zipData = ZIP_CODE_DATA.find(entry => entry.Code === selectedZipCode);
                if (zipData) {
                    // Auto-populate state and city
                    const stateSelect = document.getElementById('state');
                    const citySelect = document.getElementById('city');
                    
                    // Set state
                    stateSelect.value = zipData.State;
                    
                    // Enable and populate city dropdown
                    handleStateChange(stateSelect);
                    
                    // Set city
                    citySelect.value = zipData.City;
                    
                    // Clear error messages
                    ['city', 'state', 'zipcode'].forEach(field => {
                        const errorElement = document.getElementById(field + '-error-message');
                        if (errorElement) {
                            errorElement.textContent = '';
                        }
                    });
                    
                    handleErrorCheck();
                }
            }



            // Toggle address dropdown function
            function toggleAddressDropdown(fieldId) {
                const dropdown = document.getElementById('dropdown-' + fieldId);
                const isVisible = dropdown.classList.contains('show');
                
                // Reset all arrows to down position first
                document.querySelectorAll('.address-display .arrow').forEach(arrow => {
                    arrow.classList.remove('up');
                    arrow.classList.add('down');
                });
                
                // Close all other dropdowns first
                document.querySelectorAll('.address-dropdown').forEach(dd => dd.classList.remove('show'));
                
                if (!isVisible) {
                    dropdown.classList.add('show');
                    
                    // Change arrow to up position for the opened dropdown
                    const displayElement = document.getElementById('display-' + fieldId);
                    if (displayElement) {
                        const arrow = displayElement.querySelector('.arrow');
                        if (arrow) {
                            arrow.classList.remove('down');
                            arrow.classList.add('up');
                        }
                    }
                    
                    // Populate options based on field type
                    if (fieldId === 'state') {
                        populateStateOptions();
                    } else if (fieldId === 'city') {
                        populateCityOptions();
                    } else if (fieldId === 'zipcode') {
                        populateZipCodeOptions();
                    }
                    
                    // Highlight currently selected option
                    highlightSelectedOption(fieldId);
                    
                    // Focus search input
                    const searchInput = dropdown.querySelector('.address-search');
                    if (searchInput) {
                        setTimeout(() => {
                            searchInput.focus();
                            searchInput.value = '';
                        }, 100);
                    }
                }
            }

            // Search address options function
            function searchAddressOptions(fieldId, searchTerm) {
                const optionsContainer = document.getElementById('options-' + fieldId);
                if (!optionsContainer) return;
                
                const options = optionsContainer.querySelectorAll('.address-option');
                
                options.forEach(option => {
                    const optionText = option.textContent.toLowerCase();
                    const isVisible = optionText.includes(searchTerm.toLowerCase());
                    option.style.display = isVisible ? 'block' : 'none';
                });
            }

            // Highlight selected option in dropdown
            function highlightSelectedOption(fieldId) {
                const optionsContainer = document.getElementById('options-' + fieldId);
                const hiddenInput = document.getElementById(fieldId);
                
                if (!optionsContainer || !hiddenInput) return;
                
                const currentValue = hiddenInput.value;
                const options = optionsContainer.querySelectorAll('.address-option');
                
                // Remove selected class from all options first
                options.forEach(option => option.classList.remove('selected'));
                
                // Add selected class to current value option
                if (currentValue) {
                    options.forEach(option => {
                        if (option.textContent.trim() === currentValue.trim()) {
                            option.classList.add('selected');
                            // Scroll the selected option into view
                            option.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                        }
                    });
                }
            }

            // Select address option function
            function selectAddressOption(fieldId, value, displayText) {
                const hiddenInput = document.getElementById(fieldId);
                const textElement = document.getElementById(fieldId + '-text');
                const dropdown = document.getElementById('dropdown-' + fieldId);
                const displayElement = document.getElementById('display-' + fieldId);
                
                if (hiddenInput) hiddenInput.value = value;
                if (textElement) textElement.textContent = displayText;
                if (dropdown) dropdown.classList.remove('show');
                
                // Add selected class to highlight the display element
                if (displayElement && value) {
                    displayElement.classList.add('selected');
                }
                
                // Handle cascading effects
                if (fieldId === 'state') {
                    handleStateSelection(value);
                } else if (fieldId === 'city') {
                    handleCitySelection(value);
                } else if (fieldId === 'zipcode') {
                    handleZipCodeSelection(value);
                }
                
                handleErrorCheck();
                highlightSelectedOption(fieldId);
            }

            // Handle state selection
            function handleStateSelection(stateValue) {
                const cityDropdown = document.getElementById('dropdown-city');
                const zipcodeDropdown = document.getElementById('dropdown-zipcode');
                
                // Reset city and zipcode
                document.getElementById('city').value = '';
                document.getElementById('zipcode').value = '';
                document.getElementById('city-text').textContent = 'Select City';
                document.getElementById('zipcode-text').textContent = 'Select ZIP code';
                
                // Remove selected class from city and zipcode display elements
                const cityDisplay = document.getElementById('display-city');
                const zipcodeDisplay = document.getElementById('display-zipcode');
                if (cityDisplay) {
                    cityDisplay.classList.remove('selected');
                    cityDisplay.style.pointerEvents = 'auto';
                    cityDisplay.style.opacity = '1';
                }
                if (zipcodeDisplay) {
                    zipcodeDisplay.classList.remove('selected');
                }
            }

            // Handle city selection
            function handleCitySelection(cityValue) {
                // Reset zipcode
                document.getElementById('zipcode').value = '';
                document.getElementById('zipcode-text').textContent = 'Select ZIP code';
                
                // Remove selected class from zipcode display element
                const zipcodeDisplay = document.getElementById('display-zipcode');
                if (zipcodeDisplay) {
                    zipcodeDisplay.classList.remove('selected');
                }
                
                // Auto-populate zipcode if there's only one for this city/state combination
                const stateValue = document.getElementById('state').value;
                if (stateValue && cityValue) {
                    const key = \`\${stateValue}|\${cityValue}\`;
                    const zipCodes = zipcodesByCity[key];
                    
                    if (zipCodes && zipCodes.length === 1) {
                        selectAddressOption('zipcode', zipCodes[0], zipCodes[0]);
                    }
                }
            }

            // Handle zipcode selection
            function handleZipCodeSelection(zipcodeValue) {
                // Auto-populate city and state if not already selected
                if (addressData && zipcodeValue) {
                    const entry = addressData.find(e => e.zipcode === zipcodeValue);
                    if (entry) {
                        const stateValue = document.getElementById('state').value;
                        const cityValue = document.getElementById('city').value;
                        
                        if (!stateValue) {
                            selectAddressOption('state', entry.state, entry.state);
                        }
                        if (!cityValue) {
                            selectAddressOption('city', entry.city, entry.city);
                        }
                    }
                }
            }

            // Clear address field function
            function clearAddressField(fieldId) {
                const hiddenInput = document.getElementById(fieldId);
                const textElement = document.getElementById(fieldId + '-text');
                const dropdown = document.getElementById('dropdown-' + fieldId);
                const displayElement = document.getElementById('display-' + fieldId);
                
                if (!hiddenInput) return;
                
                hiddenInput.value = '';
                
                // Update display text based on field
                const defaultTexts = {
                    state: 'Select State',
                    city: 'Select City',
                    zipcode: 'Select ZIP code',
                    country: 'Select Country'
                };
                
                if (textElement && defaultTexts[fieldId]) {
                    textElement.textContent = defaultTexts[fieldId];
                }
                
                if (dropdown) {
                    dropdown.classList.remove('show');
                }
                
                // Remove selected class to remove highlighting
                if (displayElement) {
                    displayElement.classList.remove('selected');
                }
                
                // Handle cascading effects based on which field was cleared
                if (fieldId === 'state') {
                    clearAddressField('city');
                    clearAddressField('zipcode');
                    
                    // Disable city dropdown
                    const cityDisplay = document.getElementById('display-city');
                    if (cityDisplay) {
                        cityDisplay.style.pointerEvents = 'none';
                        cityDisplay.style.opacity = '0.6';
                    }
                } else if (fieldId === 'city') {
                    clearAddressField('zipcode');
                }
                
                // Clear error messages
                const errorElement = document.getElementById(fieldId + '-error-message');
                if (errorElement) {
                    errorElement.textContent = '';
                }
                
                handleErrorCheck();
            }

            // Handle select dropdown arrows
            function handleSelectArrows() {
                // Add event listeners to all selects with arrows
                document.querySelectorAll('.custom-select-container select').forEach(select => {
                    const container = select.closest('.custom-select-container');
                    const arrow = container ? container.querySelector('.arrow') : null;
                    
                    if (arrow) {
                        select.addEventListener('focus', function() {
                            arrow.classList.remove('down');
                            arrow.classList.add('up');
                        });
                        
                        select.addEventListener('blur', function() {
                            arrow.classList.remove('up');
                            arrow.classList.add('down');
                        });
                    }
                });
            }

            // Initialize address system when page loads
            document.addEventListener('DOMContentLoaded', function() {
                initializeAddressData();
                populateStateDropdown();
                handleSelectArrows();
                
                // Close dropdowns when clicking outside
                document.addEventListener('click', function(event) {
                    const isAddressDropdown = event.target.closest('.address-selector');
                    const isCountryDropdown = event.target.closest('.country-selector');
                    
                    if (!isAddressDropdown) {
                        document.querySelectorAll('.address-dropdown').forEach(dropdown => {
                            // Only reset arrow if dropdown is actually open and being closed
                            if (dropdown.classList.contains('show')) {
                                dropdown.classList.remove('show');
                                
                                // Find the corresponding arrow and reset it
                                const dropdownId = dropdown.id; // e.g., "dropdown-state"
                                const fieldId = dropdownId.replace('dropdown-', ''); // e.g., "state"
                                const displayElement = document.getElementById('display-' + fieldId);
                                if (displayElement) {
                                    const arrow = displayElement.querySelector('.arrow');
                                    if (arrow) {
                                        arrow.classList.remove('up');
                                        arrow.classList.add('down');
                                    }
                                }
                            }
                        });
                    }
                    
                    if (!isCountryDropdown) {
                        document.querySelectorAll('.country-dropdown').forEach(dropdown => {
                            // Only reset arrow if dropdown is actually open and being closed
                            if (dropdown.classList.contains('show')) {
                                dropdown.classList.remove('show');
                                
                                // Find the corresponding arrow and reset it
                                const dropdownId = dropdown.id; // e.g., "dropdown-primaryPhoneNumber"
                                const fieldId = dropdownId.replace('dropdown-', ''); // e.g., "primaryPhoneNumber"
                                const displayElement = document.getElementById('display-' + fieldId);
                                if (displayElement) {
                                    const arrow = displayElement.querySelector('.arrow');
                                    if (arrow) {
                                        arrow.classList.remove('up');
                                        arrow.classList.add('down');
                                    }
                                }
                            }
                        });
                    }
                });
                
                // Initially disable city dropdown
                const cityDisplay = document.getElementById('display-city');
                if (cityDisplay) {
                    cityDisplay.style.pointerEvents = 'none';
                    cityDisplay.style.opacity = '0.6';
                }
            });

        </script>
    </head>
    <body class="lead-capture-form">
        <div class="lead-capture-form-container">
            <div class="lead-capture-form-container-header-img-text">
             <div class="lead-capture-form-container-header-img">
                    <img  id="formLogo" style="width:100%" alt="Logo" />
                </div>
                <div class="lead-capture-form-container-header-text" id="formName">
                </div>
            </div>
            <div class="lead-capture-form-container-form">
                <form  id="formId">`;
};

const footerHTML = `<input type="button" onclick="handleFormSubmit()" id="submit-btn"  value="Submit"/>
                </form>
            </div>
        </div>
    </body>
</html>`;

const bodyPrimaryInformationHTML = (data: any, leadOwnerOptions: any) => {
  if (data?.title === "uploadPhoto") {
    return `
                            <div class="lead-capture-form-container-form-element">
                            <div
                            class="upload-container" 
                            >
                            <input
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                ref="imageUrl"
                                name="imageUrl"
                                class="file-input"
                                id="imageUrl"
                                hidden
                                ${data?.isRequired ? "required" : ""}
                            />
                                <label type="button" for="fileInput" id="fileInputLabel" onclick="handleFileSelect()" class="upload-content">
                                    <img src='https://www.w3schools.com/w3images/avatar2.png' id="photoFile" class="upload-img" alt="Upload Icon" />
                                    <p id="imageUrl-text" class = ${data?.isRequired ? "required-element" : ""} >Upload Photo +</p>
                                </label>
                            </div>
                            <div id="imageUrl-error-message" class="error-message"></div>
                        </div>
        `;
  } else if (data?.title === "firstName") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="firstName">First Name</label>
                            <input onchange="handleErrorCheck()" type="text" id="firstName" name="firstName" placeholder="Enter First Name" maxlength=50  required>
                            <div id="firstName-error-message" class="error-message"></div>
                        </div>
         `;
  } else if (data?.title === "lastName") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} class = ${data?.isRequired ? "required-element" : ""}  for="lastName">Last Name</label>
                                <input onchange="handleErrorCheck()" type="text" id="lastName" name="lastName" placeholder="Enter Last Name" maxlength=50 required>
                                <div id="lastName-error-message" class="error-message"></div>
                            </div>
            `;
  } else if (data?.title === "middleName") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="middleName">Middle Name</label>
                                <input onchange="handleErrorCheck()" type="text" id="middleName" name="middleName" placeholder="Enter Middle Name" maxlength="50"  ${data?.isRequired ? "required" : ""}>
                                <div id="middleName-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "primaryPhoneNumber") {
    const defaultCountry = COUNTRY_CODES.find(c => c.iso2 === 'us') || COUNTRY_CODES[0];
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="primaryPhoneNumber">Primary Phone Number</label>
                                <div class="phone-input-container">
                                    <div class="country-selector">
                                        <div class="country-display" id="display-primaryPhoneNumber" onclick="toggleCountryDropdown('primaryPhoneNumber')">
                                            <span class="country-code">${defaultCountry.dialCode}</span>
                                            <i class="arrow down"></i>
                                        </div>
                                        <div class="country-dropdown" id="dropdown-primaryPhoneNumber">
                                            <input type="text" class="country-search" 
                                                   placeholder="Search country" 
                                                   oninput="searchCountries('primaryPhoneNumber', this.value)"
                                                   onclick="event.stopPropagation()" />
                                            <div class="country-options" id="options-primaryPhoneNumber">
                                                ${COUNTRY_CODES.map(
                                                  (country) => `
                                                    <div class="country-option ${country.iso2 === "us" ? "selected" : ""}" 
                                                         onclick="selectCountry('primaryPhoneNumber', '${country.dialCode}', '${country.name}', '${country.iso2}')"
                                                         data-country-name="${country.name.toLowerCase()}"
                                                         data-country-code="${country.dialCode}"
                                                         data-country-iso2="${country.iso2}">
                                                        <div class="country-option-details">
                                                            <span class="country-option-name">${country.name}</span>
                                                            <span class="country-option-code">${country.dialCode}</span>
                                                        </div>
                                                    </div>
                                                `
                                                ).join("")}
                                            </div>
                                        </div>
                                    </div>
                                    <input type="text" 
                                           id="primaryPhoneNumber-number"
                                           class="phone-number-input"
                                           data-field-id="primaryPhoneNumber"
                                           placeholder="Enter Primary Phone Number"
                                           oninput="formatPhoneNumber(this)"
                                           maxlength="15">
                                </div>
                                <input type="hidden" id="primaryPhoneNumber" name="primaryPhoneNumber" ${data?.isRequired ? "required" : ""}>
                                <input type="hidden" id="primaryPhoneNumber-country" name="primaryPhoneNumber-country" value="${defaultCountry.dialCode}">
                                <div id="primaryPhoneNumber-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "secondaryPhoneNumber") {
    const defaultCountry = COUNTRY_CODES.find(c => c.iso2 === 'us') || COUNTRY_CODES[0];
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="secondaryPhoneNumber">Secondary Phone Number</label>
                                <div class="phone-input-container">
                                    <div class="country-selector">
                                        <div class="country-display" id="display-secondaryPhoneNumber" onclick="toggleCountryDropdown('secondaryPhoneNumber')">
                                            <span class="country-code">${defaultCountry.dialCode}</span>
                                            <i class="arrow down"></i>
                                        </div>
                                        <div class="country-dropdown" id="dropdown-secondaryPhoneNumber">
                                            <input type="text" class="country-search" 
                                                   placeholder="Search country" 
                                                   oninput="searchCountries('secondaryPhoneNumber', this.value)"
                                                   onclick="event.stopPropagation()" />
                                            <div class="country-options" id="options-secondaryPhoneNumber">
                                                ${COUNTRY_CODES.map(
                                                  (country) => `
                                                    <div class="country-option ${country.iso2 === "us" ? "selected" : ""}" 
                                                         onclick="selectCountry('secondaryPhoneNumber', '${country.dialCode}', '${country.name}', '${country.iso2}')"
                                                         data-country-name="${country.name.toLowerCase()}"
                                                         data-country-code="${country.dialCode}"
                                                         data-country-iso2="${country.iso2}">
                                                        <div class="country-option-details">
                                                            <span class="country-option-name">${country.name}</span>
                                                            <span class="country-option-code">${country.dialCode}</span>
                                                        </div>
                                                    </div>
                                                `
                                                ).join("")}
                                            </div>
                                        </div>
                                    </div>
                                    <input type="text" 
                                           id="secondaryPhoneNumber-number"
                                           class="phone-number-input"
                                           data-field-id="secondaryPhoneNumber"
                                           placeholder="Enter Secondary Phone Number"
                                           oninput="formatPhoneNumber(this)"
                                           maxlength="15">
                                </div>
                                <input type="hidden" id="secondaryPhoneNumber" name="secondaryPhoneNumber" ${data?.isRequired ? "required" : ""}>
                                <input type="hidden" id="secondaryPhoneNumber-country" name="secondaryPhoneNumber-country" value="${defaultCountry.dialCode}">
                                <div id="secondaryPhoneNumber-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "email") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="email">Primary Email</label>
                                <input onchange="handleErrorCheck()" type="email" id="email" name="email" placeholder="Enter Primary Email" ${data?.isRequired ? "required" : ""}>
                                <div id="email-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "secondaryEmail") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="secondaryEmail">Secondary Email</label>
                                <input type="email" onchange="handleErrorCheck()" id="secondaryEmail" name="secondaryEmail" placeholder="Enter Secondary Email" ${data?.isRequired ? "required" : ""}>
                                <div id="secondaryEmail-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "leadOwner") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="leadOwner">Lead Owner</label>
                            <div class="custom-select-container">
                                <select onchange="handleErrorCheck()" id="leadOwner" name="leadOwner">
                                    <option value=${leadOwnerOptions?.value || ""}>${leadOwnerOptions?.value || ""}</option>
                                </select>
                                <i class="arrow down"></i>
                            </div>
                            <div id="leadOwner-error-message" class="error-message"></div>
                        </div>
        `;
  } else if (data?.title === "leadSource") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="leadSource">Lead Source</label>
                            <div class="custom-select-container">
                                <select onchange="handleErrorCheck()" id="leadSource" name="leadSource"  ${data?.isRequired ? "required" : ""}>
                                    <option value="Manual">Manual</option>
                                    <option value="Advertisement">Advertisement</option>
                                    <option value="Call" >Call</option>
                                    <option value="Agent">Agent</option>
                                    <option value="External Referral">External Referral</option>
                                    <option value="Email Query">Email Query</option>
                                    <option value="X (Twitter)">X (Twitter)</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Partner">Partner</option>
                                    <option value="Public Relations">Public Relations</option>
                                    <option value="Sales Email">Sales Email</option>
                                    <option value="Seminar Partner">Seminar Partner</option>
                                    <option value="Internal Seminar">Internal Seminar</option>
                                    <option value="Web Research">Web Research</option>
                                    <option value="Chatbot">Chatbot</option>
                                    <option value="Horizon">Horizon</option>
                                </select>
                                <i class="arrow down"></i>
                            </div>
                            <div id="leadSource-error-message" class="error-message"></div>
                        </div>`;
  } else if (data?.title === "leadValue") {
    return `
                              <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="leadValue">Lead Value ($)</label>
                            <input onchange="handleErrorCheck()" type="number" id="leadValue"  name="leadValue" min="1" step="1"   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"  placeholder="Enter Revenue Amount" maxlength="15"  ${data?.isRequired ? "required" : ""}>
                            <div id="leadValue-error-message" class="error-message"></div>
                        </div>
        `;
  } else if (data?.title === "age") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="age">Age (years)</label>
                                <input onchange="handleErrorCheck()"  type="number" id="age" min="1" step="1"  name="age" max=120 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"  maxlength="3"  placeholder="Enter Age (years)" ${data?.isRequired ? "required" : ""}>
                                <div id="age-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "maritalStatus") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="maritalStatus">Marital Status</label>
                            <select onchange="handleErrorCheck()"  id="maritalStatus" name="maritalStatus" placeholder="Select Marital Status"  ${data?.isRequired ? "required" : ""}>
                                 <option value="" disabled selected>Select Marital Status</option>
                                <option value="Married">Married</option>
                                <option value="Single">Single</option>
                                <option value="Divorced">Divorced</option>
                                <option value="Widowed" >Widowed</option>
                                <option value="Separated">Separated</option>
                                <option value="Partnered">Partnered</option>
                                <option value="Prefer not to say">Prefer not to say</option>
                            </select>
                            <div id="maritalStatus-error-message" class="error-message"></div>
                        </div>`;
  } else if (data?.title === "preferredContactMode") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="preferredContactMode">Preferred Contact Mode</label>
                            <select onchange="handleErrorCheck()"  id="preferredContactMode" name="preferredContactMode" placeholder="Select Preferred Contact Mode"  ${data?.isRequired ? "required" : ""}>
                                 <option value="" disabled selected>Select Preferred Contact Mode</option>
                                <option value="Email">Email</option>
                                <option value="Phone Call">Phone Call</option>
                                <option value="In-Person Meeting">In-Person Meeting</option>
                                <option value="No Preference" >No Preference</option>
                            </select>
                            <div id="preferredContactMode-error-message" class="error-message"></div>
                        </div>`;
  } else if (data?.title === "website") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="website">Website</label>
                                <input onchange="handleErrorCheck()"  type="text" id="website" name="website" placeholder="Enter Website" maxlength="500" ${data?.isRequired ? "required" : ""}>
                                <div id="website-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "fax") {
    const defaultCountry = COUNTRY_CODES.find(c => c.iso2 === 'us') || COUNTRY_CODES[0];
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="fax">Fax</label>
                                <div class="phone-input-container">
                                    <div class="country-selector">
                                        <div class="country-display" id="display-fax" onclick="toggleCountryDropdown('fax')">
                                            <span class="country-code">${defaultCountry.dialCode}</span>
                                            <i class="arrow down"></i>
                                        </div>
                                        <div class="country-dropdown" id="dropdown-fax">
                                            <input type="text" class="country-search" 
                                                   placeholder="Search country" 
                                                   oninput="searchCountries('fax', this.value)"
                                                   onclick="event.stopPropagation()" />
                                            <div class="country-options" id="options-fax">
                                                ${COUNTRY_CODES.map(
                                                  (country) => `
                                                    <div class="country-option ${country.iso2 === "us" ? "selected" : ""}" 
                                                         onclick="selectCountry('fax', '${country.dialCode}', '${country.name}', '${country.iso2}')"
                                                         data-country-name="${country.name.toLowerCase()}"
                                                         data-country-code="${country.dialCode}"
                                                         data-country-iso2="${country.iso2}">
                                                        <div class="country-option-details">
                                                            <span class="country-option-name">${country.name}</span>
                                                            <span class="country-option-code">${country.dialCode}</span>
                                                        </div>
                                                    </div>
                                                `
                                                ).join("")}
                                            </div>
                                        </div>
                                    </div>
                                    <input type="text" 
                                           id="fax-number"
                                           class="phone-number-input"
                                           data-field-id="fax"
                                           placeholder="Enter Fax Number"
                                           oninput="formatPhoneNumber(this)"
                                           maxlength="15">
                                </div>
                                <input type="hidden" id="fax" name="fax" ${data?.isRequired ? "required" : ""}>
                                <input type="hidden" id="fax-country" name="fax-country" value="${defaultCountry.dialCode}">
                                <div id="fax-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "industry") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="industry">Industry</label>
                                <input onchange="handleErrorCheck()"  type="text" id="industry" name="industry" placeholder="Enter Industry" maxlength="50" ${data?.isRequired ? "required" : ""}>
                                <div id="industry-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "designation") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="designation">Designation</label>
                                <input onchange="handleErrorCheck()"  type="text" id="designation" name="designation" placeholder="Enter Designation" maxlength="100" ${data?.isRequired ? "required" : ""}>
                                <div id="designation-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "socialLeadId") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="socialLeadId">Social Lead Id</label>
                                <input onchange="handleErrorCheck()"  type="text" id="socialLeadId" name="socialLeadId" placeholder="Enter Social Lead Id" maxlength="50" ${data?.isRequired ? "required" : ""}>
                                <div id="socialLeadId-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "company") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="company">Company</label>
                                <input onchange="handleErrorCheck()"  type="text" id="company" name="company" placeholder="Enter Company" maxlength="50" ${data?.isRequired ? "required" : ""}>
                                <div id="company-error-message" class="error-message"></div>
                            </div>
        `;
  } else if (data?.title === "description") {
    return `
                            <div class="lead-capture-form-container-form-element">
                                <label class = ${data?.isRequired ? "required-element" : ""} for="description">Description</label>
                                <input onchange="handleErrorCheck()"  type="text" id="description" name="description" placeholder="Add Description" maxlength="150" ${data?.isRequired ? "required" : ""}>
                                <div id="description-error-message" class="error-message"></div>
                            </div>
    `;
  } else if (data?.title === "interestedProduct") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="interestedProduct">Interested Product</label>
                            <div class="custom-multiselect-container">
                                <div class="custom-multiselect-display" 
                                     onclick="toggleInterestedProductDropdown()" 
                                     id="interestedProduct-display"
                                     tabindex="0"
                                     role="button"
                                     aria-haspopup="listbox"
                                     aria-expanded="false">
                                    Select Interested Product
                                    <i class="arrow down"></i>
                                </div>
                                <div class="custom-multiselect-dropdown" id="interestedProduct-dropdown">
                                    <label class="checkbox-container">
                                        <input type="checkbox" value="Pre-Need" onchange="updateInterestedProductSelection()">
                                        <span class="checkmark"></span>
                                        Pre-Need
                                    </label>
                                    <label class="checkbox-container">
                                        <input type="checkbox" value="At-Need" onchange="updateInterestedProductSelection()">
                                        <span class="checkmark"></span>
                                        At-Need
                                    </label>
                                    <label class="checkbox-container">
                                        <input type="checkbox" value="Consultation" onchange="updateInterestedProductSelection()">
                                        <span class="checkmark"></span>
                                        Consultation
                                    </label>
                                    <label class="checkbox-container">
                                        <input type="checkbox" value="Miscellaneous" onchange="updateInterestedProductSelection()">
                                        <span class="checkmark"></span>
                                        Miscellaneous
                                    </label>
                                </div>
                                <input type="hidden" id="interestedProduct" name="interestedProduct" ${data?.isRequired ? "required" : ""}>
                            </div>
                            <div id="interestedProduct-error-message" class="error-message"></div>
                        </div>`;
  } else if (data?.title === "rating") {
    return `
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="rating">Confidence Score</label>
                            <select onchange="handleErrorCheck()"  id="rating" name="rating" placeholder="Select Confidence Score"  ${data?.isRequired ? "required" : ""}>
                                <option value="" disabled selected>Select Confidence Score</option>
                                <option value="not-interested">Not Interested</option>
                                <option value="least-interest" >Least Interest</option>
                                <option value="low-interest">Low Interest</option>
                                <option value="slight-interest">Slight Interest</option>
                                <option value="mild-interest">Mild Interest</option>
                                <option value="moderate-interest">Moderate Interest</option>
                                <option value="interested-engaged">Interested & Engaged</option>
                                <option value="high-interest">High Interest</option>
                                <option value="immediate-interest">Immediate Interest</option>
                                <option value="engage-convert" >Engage & Convert</option>
                            </select>
                            <div id="rating-error-message" class="error-message"></div>
                        </div>
        `;
  } else if (data?.title === "leadStatus") {
    return `
                            <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="leadStatus">Lead Status</label>
                            <select onchange="handleErrorCheck()" id="leadStatus" name="leadStatus" placeholder="Select Lead Status"  ${data?.isRequired ? "required" : ""}>
                                <option value="New Lead">New Lead</option>
                                <option value="Not Qualified" >Not Qualified</option>
                                <option value="Qualified">Qualified</option>
                                <option value="Contact Attempted">Contact Attempted</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Converted">Converted</option>
                                <option value="Closed-Won">Closed-Won</option>
                                <option value="Closed-Lost">Closed-Lost</option>
                            </select>
                            <div id="leadStatus-error-message" class="error-message"></div>
                        </div>
    `;
  } else {
    return;
  }
};

const bodyAddressInformationHTML = (data: any) => {
  if (data?.title === "address") {
    return `
                    <div class="lead-capture-form-container-form-secton">
                        <div class="lead-capture-form-container-form-secton-header">
                            Address Information
                        </div>
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="streetAddres">Street Address</label>
                            <input onchange="handleErrorCheck()"  type="text" id="streetAddress" name="streetAddress" maxlength="50" placeholder="Enter Street Address" ${data?.isRequired ? "required" : ""}>
                            <div id="streetAddress-error-message" class="error-message"></div>
                        </div>
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="state">State</label>
                            <div class="address-select-container">
                                <div class="address-selector">
                                    <div class="address-display" id="display-state" onclick="toggleAddressDropdown('state')">
                                        <span class="address-text" id="state-text">Select State</span>
                                        <i class="arrow down"></i>
                                    </div>
                                    <div class="address-dropdown" id="dropdown-state">
                                        <input type="text" class="address-search" 
                                               placeholder="Search state" 
                                               oninput="searchAddressOptions('state', this.value)"
                                               onclick="event.stopPropagation()" />
                                        <div class="address-options" id="options-state"></div>
                                        <button type="button" class="address-clear-btn" onclick="clearAddressField('state')" title="Clear selection">×</button>
                                    </div>
                                </div>
                                <input type="hidden" id="state" name="state" ${data?.isRequired ? "required" : ""}>
                            </div>
                            <div id="state-error-message" class="error-message"></div>
                        </div>
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="city">City</label>
                            <div class="address-select-container">
                                <div class="address-selector">
                                    <div class="address-display" id="display-city" onclick="toggleAddressDropdown('city')">
                                        <span class="address-text" id="city-text">Select City</span>
                                        <i class="arrow down"></i>
                                    </div>
                                    <div class="address-dropdown" id="dropdown-city">
                                        <input type="text" class="address-search" 
                                               placeholder="Search city" 
                                               oninput="searchAddressOptions('city', this.value)"
                                               onclick="event.stopPropagation()" />
                                        <div class="address-options" id="options-city"></div>
                                        <button type="button" class="address-clear-btn" onclick="clearAddressField('city')" title="Clear selection">×</button>
                                    </div>
                                </div>
                                <input type="hidden" id="city" name="city" ${data?.isRequired ? "required" : ""}>
                            </div>
                            <div id="city-error-message" class="error-message"></div>
                        </div>
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="country">Country</label>
                            <div class="address-select-container">
                                <select id="country" name="country" onchange="handleErrorCheck()" ${data?.isRequired ? "required" : ""}>
                                    <option value="">Select Country</option>
                                    <option value="United States" selected>United States</option>
                                </select>
                            </div>
                            <div id="country-error-message" class="error-message"></div>
                        </div>
                        <div class="lead-capture-form-container-form-element">
                            <label class = ${data?.isRequired ? "required-element" : ""} for="zipcode">Zip Code</label>
                            <div class="address-select-container">
                                <div class="address-selector">
                                    <div class="address-display" id="display-zipcode" onclick="toggleAddressDropdown('zipcode')">
                                        <span class="address-text" id="zipcode-text">Select ZIP code</span>
                                        <i class="arrow down"></i>
                                    </div>
                                    <div class="address-dropdown" id="dropdown-zipcode">
                                        <input type="text" class="address-search" 
                                               placeholder="Search ZIP code" 
                                               oninput="searchAddressOptions('zipcode', this.value)"
                                               onclick="event.stopPropagation()" />
                                        <div class="address-options" id="options-zipcode"></div>
                                        <button type="button" class="address-clear-btn" onclick="clearAddressField('zipcode')" title="Clear selection">×</button>
                                    </div>
                                </div>
                                <input type="hidden" id="zipcode" name="zipcode" ${data?.isRequired ? "required" : ""}>
                            </div>
                            <div id="zipcode-error-message" class="error-message"></div>
                        </div> 
                    </div>
        `;
  } else {
    return;
  }
};

export const getLeadCaptureFormHtml = (
  formName: any,
  list: any,
  createLeadCaptureId: any,
  useLeadOwnerOptions: any
) => {
  const leadOwnerOptions =
    useLeadOwnerOptions?.length > 0 ? useLeadOwnerOptions[0] : "";
  const elementPrimaryInformation = list?.map((data: any) =>
    bodyPrimaryInformationHTML(data, leadOwnerOptions)
  );
  const elementAddressInformation = list?.map((data: any) =>
    bodyAddressInformationHTML(data)
  );
  const htmlForm = `${headerHTML(formName, createLeadCaptureId)}
                    <div class="lead-capture-form-container-form-secton">
                        <div class="lead-capture-form-container-form-secton-header">
                            Primary Information
                        </div>
                    ${elementPrimaryInformation?.join("")}
                    </div>
                        ${elementAddressInformation?.join("")}

    ${footerHTML}`;
  const file = new File([htmlForm], `${formName}.html`, {
    type: "text/html",
  });
  return file;
};
